import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ICustomError } from '@shared/result/interfaces';
import { CompaniesService } from '@services/companies.service';
import { CompanyModel } from '@data-layer/models/companies';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { enumBondRequestResultError } from '@app/modules/company/enums';

@Component({
  selector: 'app-company-bond-request-result-page',
  templateUrl: './company-bond-request-result-page.component.html',
  styleUrls: ['./company-bond-request-result-page.component.scss'],
})
export class CompanyBondRequestResultPageComponent implements OnInit, OnDestroy {
  public error: ICustomError;
  public company: CompanyModel;

  private isDestroy: ReplaySubject<boolean> = new ReplaySubject<boolean>();

  constructor(private activatedRoute: ActivatedRoute, private router: Router, private companiesService: CompaniesService) {}

  public ngOnInit(): void {
    const errorMessage = this.activatedRoute.snapshot.queryParams.error;
    this.error = errorMessage ? this.getErrorMessage(+errorMessage) : undefined;

    this.companiesService.companyChange$.pipe(takeUntil(this.isDestroy)).subscribe(() => {
      this.company = this.companiesService.getCompany();
    });
  }

  public ngOnDestroy(): void {
    this.isDestroy.next(true);
    this.isDestroy.complete();
  }

  public goToRequest() {
    this.router.navigate(
      ['/companies', 'bond-request', 'view'],
      this.activatedRoute.snapshot.queryParams['saveParams'] ? { queryParamsHandling: 'merge' } : undefined,
    );
  }

  private getErrorMessage(messageCode: enumBondRequestResultError) {
    switch (messageCode) {
      case enumBondRequestResultError.PAYMENT:
        return {
          title: 'INFO.RESULT.ERROR.TITLE_1',
          messages: [{ displayMessage: 'INFO.RESULT.ERROR.TEXT_BOND_REQUEST' }],
        };
      case enumBondRequestResultError.SENDING:
      case enumBondRequestResultError.UNKNOWN:
      default:
        return {
          title: 'INFO.RESULT.ERROR.TITLE_NOT_SEND',
          messages: [{ displayMessage: 'INFO.RESULT.ERROR.TEXT_BOND_REQUEST' }],
        };
    }
  }
}
